const features = [
  {
    icon: "ri-user-star-line",
    title: "원장 직강 시스템",
    desc: "EBS 등 20여년 강의 경력의 김희삼 원장님이 직접 강의합니다. 수업 질이 흔들리지 않습니다.",
  },
  {
    icon: "ri-focus-3-line",
    title: "개별 맞춤식 / 과외식 수업",
    desc: "학생 개개인의 수준과 목표에 맞춘 1:1 수준의 소수정예 맞춤 수업을 진행합니다.",
  },
  {
    icon: "ri-medal-line",
    title: "정통파 수리논술 전문",
    desc: "20년 외길, 대치동 최고 수준의 수리논술·수능·내신 전문 강의 시스템을 자랑합니다.",
  },
];

export default function WhyFMASection() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-[#1E3A5F] mb-3">
          왜 <span className="text-[#2563EB]">FMA수학</span>인가요?
        </h2>
        <p className="text-slate-500">학생과 학부모가 신뢰하는 3가지 이유</p>
      </div>
      <div className="grid md:grid-cols-3 gap-8">
        {features.map((feature) => (
          <div
            key={feature.title}
            className="bg-white rounded-2xl p-8 text-center hover:-translate-y-1 transition-all duration-300 border border-slate-100"
          >
            <div className="w-16 h-16 bg-[#2563EB]/10 rounded-2xl flex items-center justify-center mx-auto mb-5">
              <i className={`${feature.icon} text-2xl text-[#2563EB]`} />
            </div>
            <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">{feature.title}</h3>
            <p className="text-slate-500 leading-relaxed">{feature.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
